export class ParticipationCompletion {
  redirect_url: string;

  constructor(v: Partial<ParticipationCompletion>) {
    this.redirect_url = v?.redirect_url ?? '';
  }
}

